import { render, staticRenderFns } from "./priority-list.vue?vue&type=template&id=2ad065b6&scoped=true&"
import script from "./priority-list.vue?vue&type=script&lang=ts&"
export * from "./priority-list.vue?vue&type=script&lang=ts&"
import style0 from "./priority-list.vue?vue&type=style&index=0&id=2ad065b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad065b6",
  null
  
)

export default component.exports